















import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { checkNameDuplicated } from '@/utils'

export default mixins(vwDialogMixin).extend({
  data () {
    return {
      newName: ''
    }
  },
  computed: {
    vw (): IVW | null { return this.dialog.vw },
    nameDuplicated (): boolean {
      if (!this.vw) {return false}
      return checkNameDuplicated(this.newName, this.vw.name, this.$state.device.vwList)
    }
  },
  methods: {
    async apply () {
      if (!this.vw) { return }
      const ok = await easyapi.renameVw(this.vw.id, this.newName)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  watch: {
    vw (vw: IVW | null) {
      if (vw) { this.newName = vw.name }
    }
  }
})
